import React from "react";

import NavRailLead from "components/navRail/NavRailLead";
import NavRailContent from "components/navRail/NavRailContent";
import NavRailTail from "components/navRail/NavRailTail";

import useRepoLinks from "hooks/useRepoLinks";

import DashboardIcon from "assets/svg/dashboard.svg";
import AccountsIcon from "assets/svg/accounts.svg";
import LicensesIcon from "assets/svg/licenses.svg";
import VersionsIcon from "assets/svg/versions.svg";
import PackagesIcon from "assets/svg/packages.svg";
import PhoneIcon from "assets/svg/phone.svg";
import UpdateIcon from "assets/svg/update.svg";
import LogIcon from "assets/svg/log.svg";

import {
  VIEW_ACCOUNTS_PERMISSION,
  VIEW_ACTION_LOG_PERMISSION,
  VIEW_DASHBOARD_PERMISSION,
  VIEW_IU_VERSIONS_PERMISSION,
  VIEW_PANEL_UPGRADE_PACKAGES,
} from "constants/permissions";

const NavRail = () => {
  const {
    dashboardLink,
    accountLink,
    licensesLink,
    versionsLink,
    packagesLink,
    pushCentersLink,
    incrementalUpgradeLink,
    actionLogLink,
  } = useRepoLinks();

  const items = [
    {
      link: dashboardLink,
      title: "Dashboard",
      Icon: DashboardIcon,
      permission: VIEW_DASHBOARD_PERMISSION,
    },
    {
      link: accountLink,
      title: "Accounts",
      Icon: AccountsIcon,
      permission: VIEW_ACCOUNTS_PERMISSION,
    },
    {
      link: licensesLink,
      title: "Licenses",
      Icon: LicensesIcon,
      permission: "ui_view_licenses",
    },
    {
      link: versionsLink,
      title: "Versions",
      Icon: VersionsIcon,
      permission: "ui_view_essentials",
    },
    {
      link: packagesLink,
      title: "Packages",
      Icon: PackagesIcon,
      permission: VIEW_PANEL_UPGRADE_PACKAGES,
    },
    {
      link: pushCentersLink,
      title: "Push centers",
      Icon: PhoneIcon,
      permission: "ui_view_push_centers",
    },
    {
      link: incrementalUpgradeLink,
      title: "Incremental upgrade",
      Icon: UpdateIcon,
      permission: VIEW_IU_VERSIONS_PERMISSION,
    },
    {
      link: actionLogLink,
      title: "Action log",
      Icon: LogIcon,
      permission: VIEW_ACTION_LOG_PERMISSION,
    },
  ];

  return (
    <aside className="app-aside">
      <NavRailLead />
      <NavRailContent items={items} />
      <NavRailTail />
    </aside>
  );
};

NavRail.propTypes = {};

export default NavRail;
